var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b2b-tooltip"},[_vm._t("activator"),_c('div',{ref:"label",staticClass:"b2b-tooltip__content"},[(_vm.label)?_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]}):_vm._e(),_vm._t("htmlcontent")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }